export default __webpack_public_path__ + "static/media/duration.c6cce87f.png";